import { Form, FormInput } from 'metrix-common3';
// biome-ignore lint/correctness/noUnusedImports: This import is necessary for the component to function correctly
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileSupernovaCommercialMemberships = ({
    pageCode,
    doUpsertPolicy,
    doGetPolicy,
    allowEdit,
    policy,
    doReducePolicyElement,
    tooltipInfo,
    validationInfo,
    doUpsertTooltipInfo,
    doReduceTooltipInfoElement,
}) => (
    <>
        <Form
            pageCode={pageCode}
            sectionCode='membershipInformation'
            header={
                <FormattedMessage id='Profile_SupernovaCommercial_Memberships.header' defaultMessage='Memberships' />
            }
            label={
                <FormattedMessage
                    id='Profile_SupernovaCommercial_Memberships.membershipInformation'
                    defaultMessage='Membership Information'
                />
            }
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            saveEvent={doUpsertPolicy}
            cancelEvent={doGetPolicy}
            allowEdit={allowEdit}
        >
            <FormInput
                fieldCode='snCommercialMembershipInfo.membershipId'
                label={
                    <FormattedMessage
                        id='Profile_SupernovaCommercial_Memberships.membershipId'
                        defaultMessage='CAA Business Membership Number'
                    />
                }
                value={policy?.membershipInfo?.membershipId}
                type='text'
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'membershipInfo.membershipId',
                        value,
                    })
                }
                allowEdit
            />
        </Form>
    </>
);

export default ProfileSupernovaCommercialMemberships;
